import type { FullPlan } from '@/types/FullPlan';

export const ParsePlanType = ({ type }: { type: FullPlan['level'] }) => {
    const base = 'inline-flex items-center rounded-lg px-2.5 py-1 text-base font-medium';
    const typeLower = type?.toLowerCase() || '';

    if (typeLower.includes('gold')) {
        return <span className={`${base} bg-[#FAE97A] text-[#94832C]`}>Gold</span>;
    }

    if (typeLower.includes('silver')) {
        return <span className={`${base} bg-[#A8AFB7] text-white`}>Silver</span>;
    }

    if (typeLower.includes('bronze') || typeLower.includes('expanded_bronze')) {
        return <span className={`${base} bg-[#E59A42] text-white`}>Bronze</span>;
    }

    if (typeLower.includes('catastrophic')) {
        return <span className={`${base} bg-[#CC6076] text-white`}>Catastrophic</span>;
    }

    if (typeLower.includes('platinum')) {
        return <span className={`${base} bg-[#8FADCF] text-[#FFFFFF]`}>Platinum</span>;
    }

    return <span className={`${base} bg-gray-100 text-gray-600`}>{type}</span>;
};

